import configureStore from "./configureStore";
import { useRegisterReducer } from "./utils";

export { useRegisterReducer };
export default configureStore;
